export enum EventPassTag {
  BANNER = 'mybayer-event-pass-banner',
  SHOW_BUTTON = 'mybayer-show-event-pass',
  DOWNLOAD_BUTTON = 'mybayer-download-event-pass',
}
